<template>
    <div class="footer">
        <p>
            <a href="/">网站首页</a>&nbsp;|&nbsp;
            <a href="/about">关于我们</a>&nbsp;|&nbsp;
            <a href="/link">友情链接</a>
            <span style="padding-left:225px;">版权所有<span style="font-family:AlibabaPuHuiTi_3_55_Regular;">©</span>北京康柏汉森医药科技咨询有限责任公司
                <a href="https://beian.miit.gov.cn" target="_blank">京ICP备01020304号</a>&nbsp;
                <a  target="_blank">技术支持：技术支持部</a>
            </span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "MyFooter",
        props: {
        },
        data() {
            return {
                Copyright: [
                    {
                        'Copyright': '版权所有©北京康柏汉森医药科技咨询有限责任公司',
                        'ICP备案号':'京ICP备01020304号',
                        '技术支持':'北京康柏汉森医药科技咨询有限责任公司',
                    },

                ],
            }
        },
        mounted() {
        },
        methods: {
        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped >
    .footer {
        background: url("../../assets/images/bg_footer.jpg") repeat-x;
        height: 38px;
        width: 980px;
        line-height: 38px;
        color: #7a797d;
        padding-left: 22px;
        margin: 0 auto;
    }
</style>
